<template>
  <div class="settings">
    <v-content class="pa-10">
      <v-row>

        <!-- Login Password -->
        <v-col cols="12" md="4" sm="12">
          <div class="title pb-5">Change Login Password</div>
          <v-card class="pa-3">
            <v-card-text>
              <v-form v-model="userPassword.valid">

                <v-text-field
                    v-model="userPassword.current"
                    :append-icon="userPassword.show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="userPassword.show ? 'text' : 'password'"
                    label="Current Login Password"
                    counter
                    @click:append="userPassword.show = !userPassword.show"
                ></v-text-field>

                <v-text-field
                    v-model="userPassword.new"
                    :append-icon="userPassword.show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="userPassword.show1 ? 'text' : 'password'"
                    label="New Login Password"
                    counter
                    @click:append="userPassword.show1 = !userPassword.show1"
                ></v-text-field>

                <v-text-field
                    v-model="userPassword.confirmNew"
                    :append-icon="userPassword.show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min, userPassword.passwordMatch ]"
                    :type="userPassword.show2 ? 'text' : 'password'"
                    label="Confirm New Login Password"
                    counter
                    @click:append="userPassword.show2 = !userPassword.show2"
                ></v-text-field>

              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey white--text" block @click="updateUserPassword" :loading="userPassword.isLoading" :disabled="!userPassword.valid">Change Login Password</v-btn>
            </v-card-actions>
          </v-card>

        </v-col>

        <!-- Show Password code -->
        <v-col cols="12" md="4" sm="12" v-if="$store.state.user.admin">
          <div class="title pb-5">Show Password Secret Code</div>
          <v-card class="pa-3">
            <v-card-text>
              <v-form v-model="showPasswordCode.valid">

                <v-text-field
                    v-model="showPasswordCode.current"
                    :append-icon="showPasswordCode.show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPasswordCode.show ? 'text' : 'password'"
                    label="Current Code"
                    counter
                    @click:append="showPasswordCode.show = !showPasswordCode.show"
                ></v-text-field>

                <v-text-field
                    v-model="showPasswordCode.new"
                    :append-icon="showPasswordCode.show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showPasswordCode.show1 ? 'text' : 'password'"
                    label="New Code"
                    counter
                    @click:append="showPasswordCode.show1 = !showPasswordCode.show1"
                ></v-text-field>

                <v-text-field
                    v-model="showPasswordCode.confirmNew"
                    :append-icon="showPasswordCode.show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min, showPasswordCode.passwordMatch ]"
                    :type="showPasswordCode.show2 ? 'text' : 'password'"
                    label="Confirm New Code"
                    counter
                    @click:append="showPasswordCode.show2 = !showPasswordCode.show2"
                ></v-text-field>

              </v-form>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey white--text" block :loading="showPasswordCode.isLoading" :disabled="!showPasswordCode.valid" @click="updateShowPasswordCode">Change Secret Code</v-btn>
            </v-card-actions>
          </v-card>

        </v-col>

        <!-- Edit Record code -->
        <v-col cols="12" md="4" sm="12" v-if="$store.state.user.admin">
          <div class="title pb-5">Edit Data Secret Code</div>
          <v-card class="pa-3">
            <v-card-text>
              <v-form v-model="editRecordCode.valid">

                <v-text-field
                    v-model="editRecordCode.current"
                    :append-icon="editRecordCode.show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="editRecordCode.show ? 'text' : 'password'"
                    label="Current Code"
                    counter
                    @click:append="editRecordCode.show = !editRecordCode.show"
                ></v-text-field>

                <v-text-field
                    v-model="editRecordCode.new"
                    :append-icon="editRecordCode.show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="editRecordCode.show1 ? 'text' : 'password'"
                    label="New Code"
                    counter
                    @click:append="editRecordCode.show1 = !editRecordCode.show1"
                ></v-text-field>

                <v-text-field
                    v-model="editRecordCode.confirmNew"
                    :append-icon="editRecordCode.show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min, editRecordCode.passwordMatch ]"
                    :type="editRecordCode.show2 ? 'text' : 'password'"
                    label="Confirm New Code"
                    counter
                    @click:append="editRecordCode.show2 = !editRecordCode.show2"
                ></v-text-field>

              </v-form>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey white--text" block :loading="editRecordCode.isLoading" :disabled="!editRecordCode.valid" @click="updateEditRecordCode">Change Secret Code</v-btn>
            </v-card-actions>
          </v-card>

        </v-col>

      </v-row>

      <v-snackbar v-model="$store.state.snackSuccess" :timeout="2000" top color="teal" dark>
          Record Updated!
      </v-snackbar>

      <v-snackbar v-model="isError" :timeout="2000" color="red" top dark>
          {{ errorMessage }}
      </v-snackbar>

    </v-content>
  </div>
</template>

<script>
import { db, auth, firebase } from '@/plugins/appfirebase'

export default {

  created() {
    // request codes from server
    this.$store.dispatch('requestCodes');
  },

  data() {
    return {
      userPassword: {
        valid: true,
        current: '',
        new: '',
        confirmNew: '',
        show: false,
        show1: false,
        show2: false,
        passwordMatch: v => v === this.userPassword.new || "Passwords do not match",
        isLoading: false
      },
      showPasswordCode: {
        valid: true,
        current: '',
        new: '',
        confirmNew: '',
        show: false,
        show1: false,
        show2: false,
        passwordMatch: v => v === this.showPasswordCode.new || "Passwords do not match",
        isLoading: false
      },
      editRecordCode: {
        valid: true,
        current: '',
        new: '',
        confirmNew: '',
        show: false,
        show1: false,
        show2: false,
        passwordMatch: v => v === this.editRecordCode.new || "Passwords do not match",
        isLoading: false
      },
      rules: {
          required: v => !!v || 'Required.',
          min: v => v.length >= 6 || 'Min 6 characters',
      },
      checkbox: false,
      isError: false,
      errorMessage: '',
      alert: false
    }
  },

  methods: {

    updateUserPassword() {
      if(this.userPassword.valid) {
        this.userPassword.isLoading = true

        const user = auth.currentUser;
        const cred = firebase.auth.EmailAuthProvider.credential( user.email, this.userPassword.current );
        user.reauthenticateWithCredential(cred).then(() => {

          user.updatePassword(this.userPassword.new)
            .then(() => { 
              this.userPassword.isLoading = false
              this.$store.dispatch('userSignOut') 
            }).catch( err => { console.log(err) })

        }).catch(error => {
          this.isError = true
          this.userPassword.isLoading = false
          this.errorMessage = error
        });
        
      }
    },

    updateShowPasswordCode() {
      if(this.showPasswordCode.valid && this.showPasswordCode.current === this.$store.state.codes.pwd) {
        this.showPasswordCode.isLoading = true
        db.collection('codes').doc('secret').update({ pwd: this.showPasswordCode.new })
          .then(() => { 
            this.$store.state.snackSuccess = true;
            this.showPasswordCode.isLoading = false 
            this.showPasswordCode.current = ''
            this.showPasswordCode.new = ''
            this.showPasswordCode.confirmNew = ''
          }).catch( err => { console.log(err) })
      } else {
          this.isError = true
          this.showPasswordCode.isLoading = false
          this.errorMessage = 'Current Code is not correct'
      }
    },

    updateEditRecordCode() {
      if(this.editRecordCode.valid && this.editRecordCode.current === this.$store.state.codes.edit) {
        this.editRecordCode.isLoading = true
        db.collection('codes').doc('secret').update({ edit: this.editRecordCode.new })
          .then(() => { 
            this.$store.state.snackSuccess = true; 
            this.editRecordCode.isLoading = false 
            this.editRecordCode.current = ''
            this.editRecordCode.new = ''
            this.editRecordCode.confirmNew = ''
          }).catch( err => { console.log(err) })
      } else {
        this.isError = true
        this.editRecordCode.isLoading = false
        this.errorMessage = 'Current Code is not correct'
      }
    },

  },

}
</script>

<style>

</style>